export default {
  init() {

  },
  finalize() {
    $('.global-search-toggle').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();

      $('.global-search').addClass('show');
      $('body').addClass('overflow-hidden');

      setTimeout(() => {
        $('.global-search .search-input').trigger('focus');
      }, 500);
    });

    const $globalSearch = $('.global-search');
    //$globalSearch.css({ 'height': $(window).innerHeight() + 'px' });

    function doSearch(query) {
      // Set the search position
      $globalSearch.addClass('searched');
      
      // Clear the results wrap
      $globalSearch.find('.search-results-wrap').empty();
      $globalSearch.find('.search-results-wrap').addClass('hide');

      if (query == '') {
        // No input, reset the screen. Show the suggest searches.
        $globalSearch.find('.search-featured').show().removeClass('hide');
        $globalSearch.find('.search-results-label').addClass('hide').hide();
        $globalSearch.find('.search-results-null').addClass('hide').hide();
      } else {
        // Hide the suggested searches
        $globalSearch.find('.search-featured').addClass('hide');
        $globalSearch.find('.search-results-label').addClass('hide').hide();
        $globalSearch.find('.search-results-null').addClass('hide').hide();

        // Wait for the suggested searches to finish hiding.
        setTimeout(() => {

          $globalSearch.find('.search-featured').hide();
          $globalSearch.find('.search-results-wrap').hide();

          // Send the Ajax request.
          $.ajax({
            url: '/wp-json/search/v1/get',
            method: 'GET',
            data: {
              q: query,
            },
          }).done(function(e) {
            if (Array.isArray(e)) {

              $globalSearch.find('.search-results-label .search-results-quantity').html(e.length);
              $globalSearch.find('.search-results-label .search-results-query').html(`'${query}'`);

              if (e.length == 0) {

                // No results.
                $globalSearch.find('.search-results-null').show().removeClass('hide');
                $globalSearch.find('.search-results-null .search-results-null-query').html(`'${query}'`);
                $globalSearch.find('.search-featured').show().removeClass('hide');

              } else {
                $globalSearch.find('.search-results-label').show().removeClass('hide');

                if (e.length == 1) {
                  $globalSearch.find('.search-results-for').addClass('d-none');
                  $globalSearch.find('.search-result-for').removeClass('d-none');
                } else {
                  $globalSearch.find('.search-results-for').removeClass('d-none');
                  $globalSearch.find('.search-result-for').addClass('d-none');
                }

                e.forEach((searchResult) => {
                  const $searchResult = $globalSearch.find('.search-result-dummy').clone().appendTo('.search-results-wrap');
                  $searchResult.find('.search-result-link').prop('href', searchResult.link);

                  let docIconHtml = '';
                  switch(searchResult.post_type) {
                    case 'resource':
                      docIconHtml = '<i class="icon-resource"></i>';
                      $searchResult.find('.search-result-icon').html(docIconHtml);
                      $searchResult.find('.search-result-icon').addClass('icon-resource-wrapper');
                      break;
                    case 'page':
                      docIconHtml = '<i class="icon-page"></i>';
                      $searchResult.find('.search-result-icon').html(docIconHtml);
                      $searchResult.find('.search-result-icon').addClass('icon-page-wrapper');
                      break;
                    default:
                      docIconHtml = '<i class="icon-blog"></i>';
                      $searchResult.find('.search-result-icon').html(docIconHtml);
                      $searchResult.find('.search-result-icon').addClass('icon-blog-wrapper');
                  }

                  $searchResult.find('.search-result-title').html(searchResult.title);
                  $searchResult.removeClass('search-result-dummy').addClass('search-result');
                });

                $globalSearch.find('.search-results-wrap').show().removeClass('hide');
                $globalSearch.addClass('results');
              }

            }

          });

        }, 400);
      }
    }

    // Form submit
    $globalSearch.find('#search-form').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      doSearch($globalSearch.find('#search-form .search-input').val());
    });

    // Featured search click
    $globalSearch.find('.featured-search-keyword').on('click', function() {
      $globalSearch.find('#search-form .search-input').val($(this).data('keyword'));
      doSearch($(this).data('keyword'));
    });

    // Close the dialogue
    $globalSearch.find('.search-close').on('click', function() {
      $globalSearch.removeClass('show');
      $globalSearch.removeClass('searched');
      $('body').removeClass('overflow-hidden');

      // Reset the dialogue
      resetDialogue();
    });

    // Another way of closing the dialogue
    $globalSearch.on('click', function(e) {
      if ($(e.target).parents('.inner').length == 0 && !$(e.target).hasClass('inner')) {
        $globalSearch.removeClass('show');
        $globalSearch.removeClass('searched');
        $('body').removeClass('overflow-hidden');

        // Reset the dialogue
        resetDialogue();
      }
    });

    $globalSearch.find('.search-clear').on('click', function() {
      // Reset the dialogue
      resetDialogue();
    });

    function resetDialogue() {
      $globalSearch.removeClass('searched');
      $globalSearch.find('.search-results-wrap').empty();
      $globalSearch.find('.search-featured').show().removeClass('hide');
      $globalSearch.find('.search-results-label').hide().addClass('hide');
      $globalSearch.find('.search-results-null').hide().addClass('hide');
      $globalSearch.find('.search-input').val('');
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/other/globalSearch.js